import React from "react";
import profileData from "../data/profile";

const Profile = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center mb-7 underline font-serif text-3xl font-bold text-purple-700">
          {profileData.heading}
        </h1>
        <div className="pt-4">
          <ul className="sm:text-lg">
            {profileData.points.map((p) => (
              <li key={p} className="py-2">
                <i className="fa-solid fa-arrows-to-dot mr-3"></i>
                {p}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Profile;
